import Vue from 'vue'
import Cookies from 'js-cookie'
import api from '@/api/user'
import store from '../index'
import router from '@/router'
// import util from '@/utils'
import md5 from 'js-md5'

import { ACCESS_TOKEN, USER_INFO, USER_NAME, AVATAR, USER_MARKET } from '@/store/mutation-types'
const domain = function () {
  let currentEnv = process.env.NODE_ENV
  if (currentEnv === 'development') { // 当前是否是本地环境
    return ''
  } else {
    // 根据当前url拿域名。
    let fullDomain = document.domain
    let regIP = /((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
    if (regIP.test(fullDomain)) { // 如果是IP访问
      return ''
    } else {
      return fullDomain.substr(fullDomain.indexOf('.'))
    }
  }
}
const user = {
  state: {
    token: '',
    name: '',
    avatar: '',
    permissibleMenu: [],
    info: {},
    marketCodes: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      if (token == null) token = ''
      state.token = token
      // Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
      Cookies.set(ACCESS_TOKEN, token, { path: '/', domain: domain() })
    },
    SET_NAME: (state, name) => {
      state.name = name
      Vue.ls.set(USER_NAME, name)
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
      Vue.ls.set(AVATAR, avatar)
    },
    // 权限菜单
    SET_PERMISSIBLE_MENU: (state, permissibleMenu) => {
      state.permissibleMenu = permissibleMenu
    },
    SET_INFO: (state, info) => {
      state.info = info
      Cookies.set(USER_INFO, info, { path: '/', domain: domain() })
      Vue.ls.set('USER_INFO', info)
    },
    SET_USER_MARKET: (state, marketCodes) => {
      state.marketCodes = marketCodes
      Vue.ls.set(USER_MARKET, marketCodes)
    },
    // SER_USERACCOUNT: (state, userAccount) => {
    //   Vue.ls.set(SER_USERACCOUNT, userAccount)
    // }
  },

  actions: {
    // 单点登陆用户改变
    async changeUser ({ commit }, userName) {
      if (!Cookies.getJSON(USER_INFO)) {
        router.push({ path: '/login' })
      }
      if (Cookies.getJSON(USER_INFO) && Cookies.getJSON(USER_INFO).userName !== userName) { // 判断cookie和当前vuex中的是否相同
        commit('SET_TOKEN', Cookies.get(ACCESS_TOKEN))
        commit('SET_INFO', Cookies.getJSON(USER_INFO))
        commit('SET_NAME', Cookies.getJSON(USER_INFO).partFullName)
        router.push({ path: '/home' })
      }
    },
    // 登录
    async Login ({ commit }, userInfo) {
      const { username, password, marketId } = userInfo

      try {
        // 获取userKey和salt 进行加密
        const keyRes = await api.getUserKey({
          userName: username,
          marketId,
        })
        const userKey = keyRes.data.key
        // 两次加密
        const encryptPsw = md5(md5(password) + keyRes.data.salt)
        // 登录
        const resp = await api.login({
          userKey,
          password: encryptPsw,
          // 非加密登录参数
          // marketId,
          // username,
          // password,
        })

        const { tokenInfo, userInfo } = resp.data
        const info = {
          userId: userInfo.userId,
          userType: userInfo.userType,
          userName: userInfo.partFullName,
          userPhone: userInfo.userPhone,
          deptIds: userInfo.deptIds,
          deptNames: userInfo.deptNames,
          marketCodes: userInfo.marketCodes,
          marketId: userInfo.marketId,
          roleCodes: userInfo.roleCodes,
          roleIds: userInfo.roleIds,
          systemCodes: userInfo.systemCodes,
          tagList: userInfo.tagList,
          mobile: userInfo.mobile,
          account: userInfo.account,
          userAccount: userInfo.username,
          customerId: userInfo.customerId,
          isOauth: userInfo.isOauth,
        }

        // token
        const token = `bearer ${tokenInfo.token}`
        commit('SET_TOKEN', token)

        // 用户信息
        commit('SET_NAME', userInfo.partFullName)
        commit('SET_INFO', info)
        commit('SET_AVATAR', userInfo.avatar)
        commit('SET_USER_MARKET', userInfo.marketCodes)
        // commit('SER_USERACCOUNT', username)

        // 检验是否实名认证
        // if (!util.checkAuth(userInfo.isOauth)) {
        //   throw new Error()
        // }
      } catch (e) {
        throw e
      }
    },

    /**
     * 获取用户菜单权限
    */
    async GetPermission ({ dispatch, commit }) {
      const resp = await api.getPermission('005')

      const permissibleMenu = resp.data

      commit('SET_PERMISSIBLE_MENU', permissibleMenu)
      return permissibleMenu
    },

    /**
     * 获取用户操作权限
     * @param {string} menuId 当前页面菜单id
    */
    async GetAction ({ commit }, menuId) {
      const resp = await api.getAction(menuId)
      let btnList = {}
      resp.data.map(item => {
        btnList[item.menuCode] = true
        btnList[item.menuName] = item.menuName
      })
      store.commit('changeBtnList', btnList)
      sessionStorage.setItem('btnList', JSON.stringify(btnList))
      return resp.data
    },

    // 登出
    Logout ({ commit }) {
      commit('SET_TOKEN', '')
      Cookies.remove(ACCESS_TOKEN)
      commit('SET_INFO', {})
      window.location.reload()
    }

  }
}

export default user
